export const LABELS = {
  order: 'type',
  search: '',
  offset: 0,
  limit: 30,
  type: '',
  weight: '',
  showInDashboard: null,
  idLanguage: null
}

export const LANGUAGES = {
  order: 'isoCode',
  search: '',
  offset: 0,
  limit: 30,
  idLanguage: null
}

export const COUNTRIES = {
  order: 'isoCode',
  search: '',
  offset: 0,
  limit: 30,
  showInDashboard: null,
  idLanguage: null
}

export const IMAGES = {
  parentName: '',
  parentId: '',
  idLanguage: '',
  relationshipId: '',
  primaryType: ''
}

export const IMAGESIZES = {
  order: 'name',
  offset: 0,
  limit: 30
}

export const DEFAULTIMAGES = {
  labelId: '',
  type: ''
}

export const TVSTATIONGROUPS = {
  order: 'order',
  offset: 0,
  limit: 30,
  tab: 0
}

export const TVSTATIONS = {
  order: 'name',
  search: '',
  groups: '',
  epgSource: '',
  broadcastsFilter: '',
  offset: 0,
  limit: 30,
  idLanguage: null,
  type: '',
  active: null,
  maturityRatingId: null,
  startLiveAsTimeshift: false,
}

export const TVCHANNELS = {
  order: 'name',
  search: '',
  offset: 0,
  type: '',
  active: null,
  limit: 30
}

export const EPGSOURCES = {
  search: '',
  order: 'parser',
  tvStationOrder: 'name',
  offset: 0,
  limit: 50,
  id: '',
  storedTvStations: false,
  includedSelect: '',
  tab: 0
}

export const CRONS = {
  order: 'title',
  offset: 0,
  limit: 30,
  tab: 0
}

export const PAIRINGTEMPLATES = {
  search: '',
  offset: 0,
  limit: 30,
  idShow: ''
}

export const EPGS = {
  episodeName: '',
  order: 'name',
  search: '',
  state: 'BROADCAST_STATE_VERIFIED,BROADCAST_STATE_UNVERIFIED,BROADCAST_STATE_UNASSIGNED',
  label: '',
  fromTimestamp: '',
  toTimestamp: '',
  createdBy: '',
  tvStations: '',
  tvStationGroup: '',
  tvStationAssignable: true,
  fulltextSearch: null,
  offset: 0,
  limit: 30,
  idLanguage: null,
  tab: 0,
  generated: false
}

export const BROADCASTS = {
  search: '',
  fromTimestamp: '',
  tvStations: '',
  tvStationGroup: '',
  createdBy: '',
  offset: 0,
  limit: 30,
  idLanguage: null,
  fulltextSearch: null,
  state: 'BROADCAST_STATE_VERIFIED,BROADCAST_STATE_UNVERIFIED,BROADCAST_STATE_UNASSIGNED',
  generated: false,
  railBroadcasts: null,
}

export const SHOWS = {
  order: 'name',
  search: '',
  searchContent: '',
  periodicity: '',
  createdBy: '',
  contentLabels: '',
  formatLabels: '',
  offset: 0,
  limit: 30,
  idLanguage: null,
  languageFilter: null,
  fulltextSearch: null,
  tab: 0
}

export const TEMPLATES = {
  search: '',
  offset: 0,
  limit: 30,
  show: null
}

export const BACKOFFICES = {
  order: 'name',
  search: '',
  offset: 0,
  limit: 30
}

export const BLACKOUTCONTENTS = {
  order: '-fromTimestamp',
  search: '',
  offset: 0,
  limit: 30,
  enabled: null,
  epgId: null,
  backofficeId: null,
  addGlobal: false,
  fromTimestamp: null,
  toTimestamp: null,
  templateId: null
}

export const BLACKOUTCONTENTTEMPLATES = {
  order: '-updated',
  search: '',
  offset: 0,
  limit: 30,
  enabled: null,
  showId: null,
  epgId: null,
  backofficeId: null,
  addGlobal: false,
  tab: 0
}

export const CURRENCIES = {
  order: 'name',
  search: '',
  offset: 0,
  limit: 30
}

export const PROVIDERS = {
  order: 'name',
  search: '',
  offset: 0,
  limit: 30,
  active: null
}

export const PACKAGES = {
  order: 'name',
  search: '',
  offset: 0,
  limit: 30,
  type: null,
  idProvider: null
}

export const VIDEOS = {
  order: 'name',
  search: '',
  offset: 0,
  limit: 30,
  active: null,
  state: null,
  idProvider: null,
}

export const MATURITYRATINGS = {
  order: 'name',
  offset: 0,
  limit: 30
}
